import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const steps = [{
  title: 'Laser Technology',
  desc: 'Vaginal rejuvenation procedures like diVa utilize advanced laser technology, like the Sciton diVa Laser, which combines two wavelengths to target different layers of vaginal tissue effectively.'
}, {
  title: 'Micro-injuries',
  desc: "The laser creates controlled micro-injuries in the vaginal tissue. These tiny injuries are strategically placed to stimulate the body's natural healing response without causing harm."
}, {
  title: 'Stimulation of Healing Response',
  desc: "The micro-injuries trigger the body's healing mechanisms, prompting the production of collagen, elastin, and other essential proteins in the vaginal tissue."
}, {
  title: 'Collagen Production',
  desc: 'Collagen is a crucial protein that provides structure and support to tissues. Increased collagen production helps to strengthen and tighten the vaginal walls, addressing concerns like laxity and vaginal looseness.'
}, {
  title: 'Elastin Production',
  desc: 'Elastin is another protein that contributes to the elasticity and flexibility of tissues. By stimulating elastin production, vaginal rejuvenation treatments help restore elasticity to the vaginal walls.'
}, {
  title: 'Tissue Regeneration',
  desc: 'As the healing process unfolds, new tissue forms to replace the old, damaged tissue. This results in the rejuvenation and revitalization of the vaginal walls.'
}, {
  title: 'Enhanced Blood Flow',
  desc: 'The thermal energy from the laser also helps to improve blood circulation in the vaginal area. Enhanced blood flow brings oxygen and nutrients to the tissues, supporting their regeneration.'
}, {
  title: 'Correction of Concerns',
  desc: 'Vaginal rejuvenation with a laser can address various concerns commonly experienced after pregnancy or due to hormonal changes, including vaginal laxity, lack of lubrication, urinary incontinence, painful intercourse and vaginal irritation.'
}, {
  title: 'Non-Invasive Procedure',
  desc: 'Laser treatments like diVa vaginal rejuvenation are minimally invasive and require no incisions or downtime. Patients can typically resume their regular activities immediately after the procedure.'
}, {
  title: 'Long-Term Results',
  desc: 'While patients may notice some improvements shortly after treatment, optimal results are usually achieved gradually over several weeks to months as collagen remodeling continues. The benefits are often long-lasting.'
}];
export function DVHowItWorks() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1038">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1039">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1040">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1041">
            Be SEXY
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1042">
            HOW DIVA LASER TREATMENT WORKS
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1043"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.7] font-body max-w-[800px]" data-id="element-1044">
            <p data-id="element-1045">
              The diVa Vaginal Laser, powered by Sciton technology, utilizes
              hybrid fractional laser technology to rebuild the vaginal wall by
              removing damaged tissue and replacing it with healthy tissue.
              Unlike other laser therapies, diVa penetrates multiple layers of
              vaginal tissue for optimal results.
            </p>
            <p data-id="element-1046">
              The first laser wavelength deeply resurfaces the layers of the
              vaginal wall, prepping old skin layers for the emergence of new
              tissue. The second laser wavelength heats the tissue layers to
              stimulate collagen production, resulting in improved and
              longer-lasting outcomes from the procedure.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="max-w-[800px] mx-auto" data-id="element-1047">
          <div className="relative" data-id="element-1048">
            <div className="absolute left-5 top-5 bottom-5 w-[2px] bg-[#FF1493]/30 hidden lg:block" data-id="element-1049"></div>

            <div className="space-y-8" data-id="element-1050">
              {steps.map((step, index) => <AnimateOnScroll key={index} delay={index * 50} data-id="element-1051">
                  <div className="flex items-start gap-6" data-id="element-1052">
                    <div className="w-10 h-10 rounded-full bg-[#FF1493] flex items-center justify-center flex-shrink-0 relative z-10" data-id="element-1053">
                      <span className="text-white text-sm font-bold font-[Poppins,_sans-serif]" data-id="element-1054">
                        {index + 1}
                      </span>
                    </div>
                    <div className="pt-1" data-id="element-1055">
                      <h3 className="text-white font-bold text-lg font-[Poppins,_sans-serif] mb-1" data-id="element-1056">
                        {step.title}
                      </h3>
                      <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-1057">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </AnimateOnScroll>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}